import { EmployeesProvider } from '@context/employees';
import { PropsWithChildren } from 'react';

export const EmployeesLayout = ({ children }: PropsWithChildren<unknown>) => {
  return <EmployeesProvider>{children}</EmployeesProvider>;
};
